import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetAuthorizedDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import momencik from '../../../common/momencik';
import numberFormatter from '../../../common/numberFormatter';
import { toDateOnly } from '../../../utils/dateUtils';
import { teamName } from '../../../utils/teamName';

interface AuthorizedSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const authorizedForGrid = (authorized: GetAuthorizedDto) => {
  return {
    key: authorized.id,
    values: {
      'authorized.systemNumber': authorized.systemNumber,
      'authorized.maxAmount': numberFormatter(authorized.maxAmount, true),
      'authorized.endDate': momencik(authorized.endDate, 'YYYY-MM-DD'),
      'employee.name': authorized.employee?.name,
      'company.shortname': authorized.company?.shortname,
      'team.name': teamName(authorized.team),
    },
    isInactive: !authorized.active,
    tdCssClass: {
      'authorized.maxAmount': 'amounts-align-right',
    },
    exportValues: {
      'authorized.maxAmount': authorized.maxAmount ?? 0,
      'authorized.endDate': toDateOnly(authorized.endDate),
    },
  };
};

export const AuthorizedSearch: React.FC<AuthorizedSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.sysNumber), property: 'authorized.systemNumber' },
    { header: t(tk.common.employee), property: 'employee.name' },
    { header: t(tk.common.company), property: 'company.shortname' },
    { header: t(tk.common.team), property: 'team.name' },
    { header: t(tk.common.endDate), property: 'authorized.endDate' },
    {
      header: t(tk.common.amount),
      property: 'authorized.maxAmount',
      exportType: 'number' as const,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="authorized.systemNumber"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.administration.noAuthorized)}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      showExport={true}
    />
  );
};
